const basicExport = {
    apiEndpoints: {
        protocol: process.env.REACT_APP_PROTOCOL,
        aiServer: process.env.REACT_APP_AI_SERVER
    },
    apiKey: process.env.REACT_APP_API_KEY

};

export default basicExport;